export function isValidTime(input: string): boolean {
  const splitedTime = input.toLocaleUpperCase().split(/[AP]M/i);
  const timePart = splitedTime[0].trim();

  const [hours, minutes] = timePart.split(':');

  if (hours === undefined || minutes === undefined) {
    return false;
  }

  const hourNumber = parseInt(hours);
  const minuteNumber = parseInt(minutes);

  if (
    isNaN(hourNumber) ||
    isNaN(minuteNumber) ||
    hourNumber < 0 ||
    hourNumber > 23 ||
    minuteNumber < 0 ||
    minuteNumber > 59
  ) {
    return false;
  }

  return true;
}
